<!-- 集体备课 -->
<template>
    <div class="collective-class">
        <div class="collective-class-top">
            <div class="title">集体备课</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teaching-info">
            <div id="collectiveEchartsId" style="width: 100%;height: 100%;"></div>
            <div class="activity-number">
                <div class="name">活动数</div>
                <div class="number">692</div>
                <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
                <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
            </div>
            <div class="join-number">
                <div class="name">参与人次</div>
                <div class="number">8692</div>
                <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
                <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div> 
  </template>
  
  <script>
  import * as echarts from 'echarts';
  export default {
    name: 'collective-class',
    components: {
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            phaseList:[
                {
                    value:500,
                    name:'小学',
                    number:50
                },
                {
                    value:250,
                    name:'初中',
                    number:25
                },
                {
                    value:250,
                    name:'高中',
                    number:25
                }
            ]
        }
    },
    methods: {
       
        initEcharts(){
            let dom = document.getElementById('collectiveEchartsId')
            let myChart = echarts.init(dom)
            let option;
            option = {
                tooltip: {
                    trigger: 'item',
                    // show: false,
                    // 数据的显示方式
                    formatter: (param) => {
                        return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
                    }
                },
                legend: {
                    selectedMode: false, // 是否允许点击
                    top: 'bottom',
                    left: '50%',
                    itemWidth: 9, //图例标记的图形宽度
                    itemHeight: 9,
                    textStyle: {
                        color: '#ffffff',
                        borderWidth: 2
                    },
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['75%', '45%'],
                        avoidLabelOverlap: false,
                        color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                        label: {
                            show: false,
                            position: 'center',
                            formatter: (data) => {
                                return (
                                "{a|" +
                                data.data.number +
                                "%}" +
                                "\r\n" +
                                "{b|" +
                                data.data.name +
                                "}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 16,
                                    lineHeight: 20,
                                    color: "#fff",
                                    align: "center",
                                    fontWeight: "bold",
                                },
                                b: {
                                    fontSize: 12,
                                    lineHeight: 16,
                                    fontWeight: "bold",
                                    color: "#7ABFDB",
                                    align: "center",
                                },
                            },
                            backgroundColor: "transparent",
                            fontWeight: "bold",
                            fontSize: "15",
                            padding: 6,
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.phaseList
                    }
                ]
            };
            option && myChart.setOption(option)
        }
    },
    mounted(){
        this.initEcharts();
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .collective-class{
    width: 100%;
    height: 270px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .collective-class-top{
        position: relative;
        text-align: center;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teaching-info{
        width: 100%;
        height: 220px;
        position: relative;
        .activity-number{
            position: absolute;
            width: 115px;
            height: 65px;
            border: 1px solid #2773E6;
            border-radius: 1px;
            top: 20px;
            left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                line-height: 18px;
            }
            .number{
                font-size: 26px;
                font-family: DigifaceWide;
                font-weight: 400;
                color: #38FFF3;
            }
        }
        .join-number{
            position: absolute;
            width: 115px;
            height: 65px;
            border: 1px solid #2773E6;
            border-radius: 1px;
            top: 125px;
            left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                line-height: 18px;
            }
            .number{
                font-size: 26px;
                font-family: DigifaceWide;
                font-weight: 400;
                color: #38FFF3;
            }
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
  }
  </style>
  <style lang="scss">
  </style>